module.exports = __webpack_public_path__ + "static/media/Expertise-Villas-Vaud.3aef79f1.jpg";